// One sound for a scan, the same on every task screen: a short high tone = counted, a low long tone = refused.
// The same tones as the packing screen (PackingWindow's playBeep), so a worker hears one language across the
// warehouse. One AudioContext per page (browsers limit how many may be open). -- Claude, 2026-10-28

let ctx: AudioContext | null = null;

export function scanSound(type: 'ok' | 'error'): void {
  try {
    ctx = ctx || new (window.AudioContext || (window as any).webkitAudioContext)();
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.connect(gain);
    gain.connect(ctx.destination);
    const len = type === 'ok' ? 0.2 : 0.5;
    osc.frequency.value = type === 'ok' ? 880 : 220;
    gain.gain.setValueAtTime(type === 'ok' ? 0.3 : 0.4, ctx.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + len);
    osc.start();
    osc.stop(ctx.currentTime + len);
  } catch {
    /* no audio on this device — the colour still says it */
  }
}
